import React from "react";
import styled from "styled-components";

function NotFound() {
  return (
    <Container>
      <div>
        <img src="/image/not_found.svg" alt="" />
        <h1>
          No data found back to <a href="/">Home</a>.
        </h1>
      </div>
    </Container>
  );
}

const Container = styled.main`
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  img {
    width: min(100%, 400px);
  }
  a {
    color: var(--link-color);
    text-decoration: none;
  }
`;

export default NotFound;
